// Account Receivable Mutations

export const updateAccountReceivableList = (state, payload) => {
  state.accountReceivableList = payload
}

export const updateAccountReceivableInfo = (state, payload) => {
  state.accountReceivableInfo = payload
}

export const updateAccountReceivableBalanceDetails = (state, payload) => {
  state.accountReceivableBalanceDetails = payload
}
